import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "max-w-4xl mx-auto" }
const _hoisted_3 = { class: "mb-6 flex flex-col gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2 text-sm font-medium text-gray-500" }
const _hoisted_5 = { class: "grid gap-6 md:grid-cols-2" }
const _hoisted_6 = { class: "bg-white border border-gray-200 rounded-2xl shadow-sm p-6" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-xs text-gray-500 flex items-center gap-1" }
const _hoisted_9 = { class: "mt-4 flex items-center gap-4" }
const _hoisted_10 = { class: "h-12 w-12 rounded-full bg-[#f6f1ec] flex items-center justify-center text-sm font-semibold text-gray-700" }
const _hoisted_11 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_12 = { class: "text-sm text-gray-600" }
const _hoisted_13 = { class: "mt-4 text-sm text-gray-600" }
const _hoisted_14 = { class: "font-medium text-gray-900" }
const _hoisted_15 = { class: "bg-primary/10 border border-primary/30 rounded-2xl shadow-sm p-6" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_19 = { class: "text-sm text-gray-700 mt-1" }
const _hoisted_20 = { class: "mt-3 inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-medium text-gray-700" }
const _hoisted_21 = { class: "bg-white border border-gray-200 rounded-2xl shadow-sm p-6 md:col-span-2" }
const _hoisted_22 = { class: "flex items-center justify-between" }
const _hoisted_23 = { class: "mt-4 grid gap-3 sm:grid-cols-2 text-sm text-gray-700" }
const _hoisted_24 = { class: "flex items-center justify-between rounded-xl border border-gray-200 px-4 py-3" }
const _hoisted_25 = { class: "font-medium text-gray-900" }
const _hoisted_26 = { class: "flex items-center justify-between rounded-xl border border-gray-200 px-4 py-3" }
const _hoisted_27 = { class: "font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!
  const _component_CalendarDaysIcon = _resolveComponent("CalendarDaysIcon")!
  const _component_CreditCardIcon = _resolveComponent("CreditCardIcon")!
  const _component_CheckBadgeIcon = _resolveComponent("CheckBadgeIcon")!
  const _component_Cog6ToothIcon = _resolveComponent("Cog6ToothIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_UserCircleIcon, { class: "h-4 w-4 text-primary" }),
          _cache[0] || (_cache[0] = _createTextVNode(" My Account "))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-3xl font-semibold text-gray-900" }, " Account Overview ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-600" }, " Review your membership, billing, and activity. ", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-600" }, " Personal Information ", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_CalendarDaysIcon, { class: "h-4 w-4" }),
              _createTextVNode(" Member since " + _toDisplayString(_ctx.formatDate(_ctx.user?.createdAt)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user?.fullName?.[0] || 'N'), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.user?.fullName), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.user?.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[4] || (_cache[4] = _createTextVNode(" Company: ")),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.user?.company || '—'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-600" }, " Billing Details ", -1)),
            _createVNode(_component_CreditCardIcon, { class: "h-5 w-5 text-primary" })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.planName), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.planPrice), 1),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_CheckBadgeIcon, { class: "h-4 w-4 text-primary" }),
              _createTextVNode(" " + _toDisplayString(_ctx.planDescription), 1)
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mt-5 flex items-center justify-between" }, [
            _createElementVNode("div", { class: "text-xs text-gray-600" }, " Next billing date: N/A "),
            _createElementVNode("button", {
              class: "inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-[#c9ad99]",
              type: "button"
            }, " Change Plan ")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-600" }, " Activity ", -1)),
            _createVNode(_component_router_link, {
              class: "inline-flex items-center gap-2 rounded-full border border-gray-300 px-3 py-1 text-xs font-medium text-gray-700 hover:bg-gray-100",
              to: "/dashboard/settings"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Cog6ToothIcon, { class: "h-4 w-4" }),
                _cache[7] || (_cache[7] = _createTextVNode(" Settings "))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-gray-500" }, "Last active", -1)),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formatDate(_ctx.user?.updatedAt)), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-gray-500" }, "Membership status", -1)),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.planName), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}